import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { useAuth } from '../../AuthProvider';

const Header = ({ onMenuClick, isMenuOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const handleLogout = async () => {
    try { await signOut(); } catch {}
    navigate('/login');
    setIsUserMenuOpen(false);
  };

  const displayName = user?.displayName || user?.email || 'Account';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-card">
      <div className="flex items-center justify-between h-14 sm:h-16 px-2 sm:px-3 lg:px-6">
        {/* Logo - Clickable to navigate to dashboard */}
        <div className="flex items-center flex-shrink-0">
          <div 
            className="flex items-center space-x-1 sm:space-x-2 cursor-pointer hover:opacity-80 transition-all" 
            onClick={() => navigate('/dashboard')}
            title="Go to Dashboard"
          >
            <div className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Package" size={14} color="white" className="sm:hidden" />
              <Icon name="Package" size={16} color="white" className="hidden sm:block lg:hidden" />
              <Icon name="Package" size={20} color="white" className="hidden lg:block" />
            </div>
            <span className="text-sm sm:text-base lg:text-xl font-semibold text-foreground hidden sm:inline">InventoryTracker</span>
            <span className="text-xs sm:text-sm font-semibold text-foreground sm:hidden">InvTrack</span>
          </div>
        </div>

        {/* User Menu & Mobile Toggle */}
        <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
          {/* Mobile Menu Toggle */}
          <Button
            variant="outline"
            size="icon"
            className={`md:hidden relative z-50 h-8 w-8 sm:h-9 sm:w-9 rounded-md border-primary/20 ${isMenuOpen ? 'bg-primary/10 border-primary' : 'bg-background/80'} shadow-sm hover:bg-background`}
            onClick={onMenuClick}
          >
            <Icon name={isMenuOpen ? "X" : "Menu"} size={18} className="text-primary" />
          </Button>

          {/* User Account Menu */}
          <div className="relative">
            <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
            className="h-8 w-8 sm:h-9 sm:w-9 rounded-full bg-muted hover:bg-muted/80"
            title={displayName}
          >
            <Icon name="User" size={14} sm="size={16}" />
            </Button>

            {isUserMenuOpen && (
              <div className="absolute right-0 top-12 w-56 bg-popover border border-border rounded-lg shadow-modal z-50">
                <div
                  className="p-3 border-b border-border cursor-pointer hover:bg-muted/40"
                  onClick={() => { setIsUserMenuOpen(false); navigate('/profile'); }}
                >
                  <p className="text-sm font-medium text-foreground truncate">{displayName}</p>
                  <p className="text-xs text-muted-foreground">View profile</p>
                </div>
                <div className="p-1">
                  <Button
                    variant="ghost"
                    className="w-full justify-start px-3 py-2 text-sm"
                    iconName="Settings"
                    iconPosition="left"
                    iconSize={16}
                    onClick={() => { setIsUserMenuOpen(false); navigate('/settings'); }}
                  >
                    Settings
                  </Button>
                  <Button
                    variant="ghost"
                    className="w-full justify-start px-3 py-2 text-sm"
                    iconName="HelpCircle"
                    iconPosition="left"
                    iconSize={16}
                    onClick={() => { setIsUserMenuOpen(false); navigate('/help'); }}
                  >
                    Help & Support
                  </Button>
                  <div className="border-t border-border my-1"></div>
                  <Button
                    variant="ghost"
                    className="w-full justify-start px-3 py-2 text-sm text-destructive hover:text-destructive"
                    iconName="LogOut"
                    iconPosition="left"
                    iconSize={16}
                    onClick={handleLogout}
                  >
                    Sign Out
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Overlay for user menu */}
      {isUserMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/20" 
          onClick={() => setIsUserMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;